import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminLogout, adminMe } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // state: null = unknown / not yet probed, false = logged out, object = logged in
  const [state, setState] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const me = await adminMe();
      setState(me);
    } catch {
      setState(false);
    }
  }, []);

  const login = useCallback(async (password) => {
    await adminLogin(password);
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    await adminLogout();
    setState(false);
  }, []);

  return (
    <AuthContext.Provider value={{ state, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const v = useContext(AuthContext);
  if (!v) throw new Error("useAuth must be used inside <AuthProvider>");
  return v;
}
